import { render, staticRenderFns } from "./transfer-list.vue?vue&type=template&id=8149a51e&"
import script from "./transfer-list.vue?vue&type=script&lang=js&"
export * from "./transfer-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports